import { createFractionsFromIds } from './createFractionsFromIds';

export const createEnabledFractionsForIds = (ids: number[]) => createFractionsFromIds(ids, 1.0);
